import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const CalenderUpIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="20"
    height="11"
    viewBox="0 0 20 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.103021 9.94463C0.103021 9.70985 0.181291 9.47507 0.376966 9.31855L9.378 0.475067C9.73021 0.122894 10.2781 0.122894 10.6303 0.475068L19.6313 9.31855C19.9836 9.67072 19.9836 10.2185 19.6313 10.5707C19.2791 10.9229 18.7312 10.9229 18.379 10.5707L10.0042 2.35333L1.62928 10.6099C1.27707 10.962 0.729181 10.962 0.376966 10.6099C0.220426 10.3751 0.103021 10.1794 0.103021 9.94463Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default CalenderUpIconDark;
